import * as React from 'react'

import { ReactComponent as CloseIcon } from '../../../Assets/close.svg'
import { ReactComponent as InfoPurpleIcon } from '../../../Assets/infoPurple.svg'
import { ReactComponent as InfoTealIcon } from '../../../Assets/infoTeal.svg'
import { ReactComponent as WarningIcon } from '../../../Assets/warning.svg'
import Headings from '../../atoms/Heading'
import Paragraph from '../../atoms/Paragraph'

interface Props {
  content?: any
  background?: string
  closeIcon?: boolean
}

/**
 * Banner Notification Component
 * @param content - Content from the CMS.
 * @param background - Background of the Alert. Expected values: "teal" | "purple" | "orange", Default: "teal"
 * @param closeIcon - Close Icon of the banner notification. Expected values: true | false, Default: false
 */
const BannerNotification = ({ background = 'teal', content }: Props) => {
  background = background.toLowerCase()
  const bgColor =
    background === 'purple'
      ? 'bg-purple-100'
      : background === 'orange'
        ? 'bg-orange-10'
        : background === 'teal'
          ? 'bg-teal-10'
          : background === 'lightpurple'
            ? 'bg-purple-10'
            : 'bg-white'
  const borderColor =
    background === 'purple'
      ? 'border-purple-100'
      : background === 'orange'
        ? 'border-orange-100'
        : background === 'teal'
          ? 'border-teal-100'
          : background === 'lightpurple'
            ? 'border-purple-100'
            : 'border-none'
  const closeIcon = content?.fields?.closeButton

  const handleClose = (e) => {
    e.stopPropagation()
    e.target.closest('.bannerNotify').style.display = 'none'
  }

  return (
    <>
      <div
        aria-label={content?.fields?.title}
        className={`bannerNotify layoutSpacing ${bgColor} border-b ${borderColor} in-pagealerts ${content?.fields?.containerBottomSpacing ? 'sectionBottomMargin' : ''}`}
      >
        <div data-testid="bannerNotification-teal" className={`layout w-100`}>
          <div className={`flex items-center justify-between gap-16 py-24 md:gap-32`}>
            <div className="flex justify-start gap-16 md:gap-32">
              <div className="min-w-[32px]">
                {background === 'orange' && <WarningIcon />}
                {background === 'teal' && <InfoTealIcon />}
                {background === 'lightpurple' && <InfoPurpleIcon />}
              </div>
              <div>
                <Headings variant="H4" content={content?.fields?.title} classes="text-black" />
                <Paragraph content={content?.fields?.message} classes="!text-base md:!text-md" />
              </div>
            </div>
            {closeIcon && (
              <div
                className="cursor-pointer self-start"
                onClick={(e) => {
                  handleClose(e)
                }}
              >
                <CloseIcon />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default BannerNotification
